<template>
  <div class="globalHead" >
    <div class="sitelogo" >
      <router-link to="/"><img class="" src="/img2022/titleH1.svg" alt="東京カメラ部2022写真展 Online Exhibition「写真との出会いは、世界との出会いだ。 - An encounter with a photo is an encounter with the world -" /></router-link>
    </div><!-- /sitelogo-->
    <nav class="globalMenuArea">
      <ul class="globalMenu pc">
        <li class="exhTxt"><router-link to="/about" :class="{ location: isSelected('/about') }">開催概要</router-link></li>
        <li><router-link to="/t10s" :class="{ location: isSelected('/t10s') }">東京カメラ部10選</router-link></li>
        <li><router-link to="/j100v" :class="{ location: isSelected('/j100v') }">日本写真100景</router-link></li>
        <li><router-link to="/sponsors" :class="{ location: isSelected('/sponsors') }">協賛展示</router-link></li>
        <li><router-link to="/organizer" :class="{ location: isSelected('/organizer') }">主催者企画</router-link></li>
      </ul>
      <p class="eventBtn"><router-link to="/reports" :class="{ location: isSelected('/reports') }"><img class="pc" src="/img2022/head_talkstagereport.png" srcset="/img2022/head_talkstagereport@2x.png 2x" alt="イベントカレンダー" /><img class="sp" src="/img2022/head_talkstagereportSp.png" srcset="/img2022/head_talkstagereportSp@2x.png 2x" alt="トークステージレポート" /></router-link></p>
      <p class="eventBtn"><router-link to="/events" :class="{ location: isSelected('/events') }"><img class="pc" src="/img2022/head_event.png" srcset="/img2022/head_event@2x.png 2x" alt="イベントカレンダー" /><img class="sp" src="/img2022/head_eventCalendar.png" srcset="/img2022/head_eventCalendar@2x.png 2x" alt="イベントカレンダー" /></router-link></p>
      <!--
      <p class="eventBtn"><router-link to="/events/archives" :class="{ location: isSelected('/events/archives') }"><img class="pc" src="/img2022/head_event.png" srcset="/img2022/head_event@2x.png 2x" alt="イベントカレンダー" /><img class="sp" src="/img2022/head_eventCalendar.png" srcset="/img2022/head_eventCalendar@2x.png 2x" alt="イベントカレンダー" /></router-link></p>
      -->
    </nav><!-- /globalMenuArea-->
  </div><!-- /globalHead-->
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
      currentScrollPosition: 0
    }
  },
  watch: {
    // モーダルウインドウが閉じられたらメインページのスクロールができるようにする
    isSpMenuOpen: function (val) {
      if (!val) {
        this.bodyFixedOff()
      }
    }
  },
  methods: {
    isSelected (str) {
      return this.$route.path.indexOf(str) >= 0
    },
    // メインページスクロール固定処理設定
    bodyFixedOn () {
      const ua = window.navigator.userAgent.toLowerCase()
      const isiOS = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || (ua.indexOf('macintosh') > -1 && 'ontouchend' in document)
      const body = document.body
      if (isiOS) {
        this.currentScrollPosition = window.pageYOffset
        body.style.position = 'fixed'
        body.style.top = `-${this.currentScrollPosition}px`
      } else {
        body.style.overflow = 'hidden'
      }
    },
    // メインページスクロール固定処理解除
    bodyFixedOff () {
      const ua = window.navigator.userAgent.toLowerCase()
      const isiOS = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || (ua.indexOf('macintosh') > -1 && 'ontouchend' in document)
      const body = document.body
      if (isiOS) {
        body.style.removeProperty('position')
        body.style.removeProperty('top')
        window.scrollTo(0, this.currentScrollPosition)
      } else {
        body.style.removeProperty('overflow')
      }
    }
  }
}
</script>
